import React from "react";
import { INSTAGRAM_URL } from "../../../helpers/socialMediaUrls";
import { StyledInstagramIcon } from './InstagramIcon.styled';

export const InstagramIcon = () => {
    return <a href={INSTAGRAM_URL} target='_blank'><StyledInstagramIcon/></a>
}